import Vue from 'vue'
import store from '~/store'
import { MODULE_TYPE_SZAFA } from '../../resource/ModuleTypes'
// state
export const state = {
  moduleType: MODULE_TYPE_SZAFA,
  moduleCurrent: [],
  modulePosition: [],
  moduleColor: 1,
  moduleShadow: true,
  showSzafaModuleArrow: true,
  windowWidth: 0,
  moduleSide: 'left'
}

// getters
export const getters = {
  /**
   * Return Modules now use
   *
   * @param state
   * @returns {Array}
   */
  moduleCurrent: state => {
    let moduleCurrent = []

    let moduleCollectionChoose = store.getters['modules/moduleCollectionChoose']

    for (var i = 0; i < state.modulePosition.length; i++) {
      moduleCurrent.push(moduleCollectionChoose.data[i][state.modulePosition[i]])
    }

    return moduleCurrent
  },

  moduleColor: state => {
    return state.moduleColor
  },
  /**
   * Return description module
   *
   * @param state
   * @param getters
   * @returns {function(*): string}
   */
  moduleDescription: (state, getters) => (index) => {
    return String(getters.moduleCurrent[index].description)
  }
}

// mutations
export const mutations = {
  SET_MODULE_SIDE (state, payload) {
    state.moduleSide = payload
  },

  setModuleColor (state, payload) {
    state.moduleColor = payload
  },

  changeModuleShadow (state, payload) {
    state.moduleShadow = payload
  },
  /**
   * Change module current state to default
   *
   * @param state
   * @constructor
   */
  DEFAULT_MODULE_CURRENT (state) {
    state.moduleSide = 'left'
    this.moduleType = MODULE_TYPE_SZAFA
  },

  /**
   * Set show module arrow
   *
   * @param state
   * @param payload
   * @constructor
   */
  SET_SHOW_MODULE_ARROW (state, payload) {
    state.showSzafaModuleArrow = payload
  },

  /**
   * Set module type
   *
   * @param state
   * @param payload
   * @constructor
   */
  SET_MODULE_TYPE (state, payload) {
    state.moduleType = payload
  },

  setModulePosition (state, payload) {
    Vue.set(state.modulePosition, payload.index, payload.position)
  },

  resetModulePosition (state, payload) {
    state.modulePosition = []

    let count = payload.length

    for (var i = 0; i < parseInt(count); i++) {
      Vue.set(state.modulePosition, i, 0)
    }
  },

  clearModuleCurrent (state) {
    state.moduleCurrent = []
    state.modulePosition = []
    state.moduleColor = 1
    state.moduleShadow = true
  }
}

// actions
export const actions = {
  async setModuleColor ({ commit }, payload) {
    try {
      commit('setModuleColor', payload)
    } catch (e) {
    }
  }
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/moduleCurrent.js